module.exports = __webpack_public_path__ + "img/record.486ba981.svg";